import { render, staticRenderFns } from "./page-info.vue?vue&type=template&id=6bc5b347&"
import script from "./page-info.vue?vue&type=script&lang=js&"
export * from "./page-info.vue?vue&type=script&lang=js&"
import style0 from "./page-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bc5b347')) {
      api.createRecord('6bc5b347', component.options)
    } else {
      api.reload('6bc5b347', component.options)
    }
    module.hot.accept("./page-info.vue?vue&type=template&id=6bc5b347&", function () {
      api.rerender('6bc5b347', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/common/page-info.vue"
export default component.exports